(function () {
	'use strict';

	// ===== Amplitude (ONY-38 / ONY-58) =====
	// The SDK is deliberately absent for bots, dev hosts and internal traffic
	// (see assets/amplitude-onyra.js), so every call must tolerate it being missing.
	function trackQuiz(eventName, props) {
		if (!window.amplitude || typeof window.amplitude.track !== 'function') return;
		props.plan_version = 'ony38-v1';
		window.amplitude.track(eventName, props);
	}

	function initQuiz(sectionEl) {
		if (!sectionEl || sectionEl.dataset.quizInitialized) return;
		sectionEl.dataset.quizInitialized = 'true';

		var sectionId = sectionEl.dataset.sectionId;
		var dataEl = document.getElementById('quiz-onyra-data-' + sectionId);
		if (!dataEl) return;

		var data;
		try {
			data = JSON.parse(dataEl.textContent);
		} catch (e) {
			console.warn('[quiz-onyra] Invalid quiz data JSON', e);
			return;
		}

		var questions = data.questions || [];
		if (questions.length === 0) return;

		// State
		var currentStep = 0;
		var votes = {};
		var voteHistory = [];
		var startTracked = false;

		// DOM refs
		var introScreen = sectionEl.querySelector('[data-screen="intro"]');
		var questionsScreen = sectionEl.querySelector('[data-screen="questions"]');
		var resultsScreen = sectionEl.querySelector('[data-screen="results"]');
		var resultsStickyEl = sectionEl.querySelector('.quiz-onyra__results-sticky');
		var progressBar = sectionEl.querySelector('[data-progress-bar]');
		var progressLabel = sectionEl.querySelector('[data-progress-label]');
		var questionText = sectionEl.querySelector('[data-question-text]');
		var answersContainer = sectionEl.querySelector('[data-answers-container]');
		var backBtn = sectionEl.querySelector('[data-action="back"]');
		var startBtn = sectionEl.querySelector('[data-action="start"]');
		var retakeBtn = sectionEl.querySelector('[data-action="retake"]');

		// Check if quiz is inside a modal
		var isModal = !!sectionEl.closest('#quiz-modal');

		// 'page' | 'modal' — the two instances share this file but have different result
		// vocabularies, so quiz_result must never be aggregated across variants (ONY-38 §5).
		var quizVariant = sectionEl.dataset.quizVariant || (isModal ? 'modal' : 'page');

		function showScreen(name) {
			if (introScreen) introScreen.style.display = name === 'intro' ? '' : 'none';
			if (questionsScreen) questionsScreen.style.display = name === 'questions' ? '' : 'none';
			if (resultsScreen) resultsScreen.style.display = name === 'results' ? '' : 'none';
			if (resultsStickyEl) resultsStickyEl.style.display = name === 'results' ? '' : 'none';
			if (isModal) {
				// Scroll modal container to top
				var container = sectionEl.closest('.quiz-modal__container');
				if (container) container.scrollTop = 0;
			} else {
				sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}

		function updateProgress() {
			var pct = ((currentStep + 1) / questions.length) * 100;
			if (progressBar) progressBar.style.setProperty('--quiz-progress', pct + '%');
			if (progressLabel) progressLabel.textContent = (currentStep + 1) + ' / ' + questions.length;
		}

		function renderQuestion(index) {
			var q = questions[index];
			if (!q) return;

			currentStep = index;
			updateProgress();

			if (questionText) questionText.textContent = q.text;

			if (answersContainer) {
				answersContainer.innerHTML = '';
				q.answers.forEach(function (answer) {
					var btn = document.createElement('button');
					btn.className = 'quiz-onyra__answer';
					btn.textContent = answer.text;
					btn.setAttribute('type', 'button');
					btn.addEventListener('click', function () {
						handleAnswer(answer.result);
					});
					answersContainer.appendChild(btn);
				});
			}

			if (backBtn) backBtn.style.display = index === 0 ? 'none' : '';

			// Trigger re-animation
			var questionArea = sectionEl.querySelector('.quiz-onyra__question-area');
			if (questionArea) {
				questionArea.style.animation = 'none';
				questionArea.offsetHeight; // force reflow
				questionArea.style.animation = '';
			}
		}

		function handleAnswer(resultId) {
			voteHistory[currentStep] = resultId;
			votes[resultId] = (votes[resultId] || 0) + 1;

			var nextStep = currentStep + 1;
			if (nextStep < questions.length) {
				renderQuestion(nextStep);
			} else {
				showResults();
			}
		}

		function handleBack() {
			if (currentStep === 0) return;

			var prevResultId = voteHistory[currentStep - 1];
			if (prevResultId && votes[prevResultId]) {
				votes[prevResultId] = Math.max(0, votes[prevResultId] - 1);
			}
			delete voteHistory[currentStep - 1];
			renderQuestion(currentStep - 1);
		}

		function pickWinner() {
			var winner = null;
			var maxVotes = 0;

			Object.keys(votes).forEach(function (id) {
				if (votes[id] > maxVotes) {
					maxVotes = votes[id];
					winner = id;
				}
			});

			// Tie-breaking: if multiple IDs share maxVotes, pick the one
			// that appears first in the DOM order of result panels
			var tiedIds = Object.keys(votes).filter(function (id) {
				return votes[id] === maxVotes;
			});

			if (tiedIds.length > 1) {
				var resultEls = sectionEl.querySelectorAll('[data-result-id]');
				for (var i = 0; i < resultEls.length; i++) {
					var rid = resultEls[i].dataset.resultId;
					if (rid !== '__empty__' && tiedIds.indexOf(rid) !== -1) {
						winner = rid;
						break;
					}
				}
			}

			return winner;
		}

		function showResults() {
			var winner = pickWinner();

			// Hide all result panels
			var allResults = sectionEl.querySelectorAll('[data-result-id]');
			allResults.forEach(function (el) {
				el.style.display = 'none';
			});

			// Show winner
			var winnerEl = winner
				? sectionEl.querySelector('[data-result-id="' + winner + '"]')
				: null;

			if (winnerEl) {
				winnerEl.style.display = '';
			} else {
				var emptyEl = sectionEl.querySelector('[data-result-id="__empty__"]');
				if (emptyEl) emptyEl.style.display = '';
			}

			showScreen('results');
			if (winner) {
				sessionStorage.setItem('quiz-onyra-result', winner);
				updatePillForSavedResult();
			}

			trackQuiz('Quiz Completed', {
				quiz_variant: quizVariant,
				quiz_result: winner || null,
				quiz_result_empty: !winnerEl,
			});
		}

		function retake() {
			currentStep = 0;
			votes = {};
			voteHistory = [];
			startTracked = false;
			sessionStorage.removeItem('quiz-onyra-result');
			resetPillText();
			showScreen('intro');
		}

		// Event binding
		if (startBtn) {
			startBtn.addEventListener('click', function () {
				showScreen('questions');
				renderQuestion(0);
				if (!startTracked) {
					startTracked = true;
					trackQuiz('Quiz Started', { quiz_variant: quizVariant });
				}
			});
		}

		if (backBtn) {
			backBtn.addEventListener('click', handleBack);
		}

		if (retakeBtn) {
			retakeBtn.addEventListener('click', retake);
		}

		// Add to Cart button
		sectionEl.addEventListener('click', function (e) {
			var addBtn = e.target.closest('[data-add-to-cart]');
			if (!addBtn || addBtn.disabled) return;
			addToCartFromQuiz(addBtn.dataset.variantId, addBtn);
		});

		sectionEl._jumpToResult = function (resultId) {
			var allResults = sectionEl.querySelectorAll('[data-result-id]');
			allResults.forEach(function (el) { el.style.display = 'none'; });
			var targetEl = sectionEl.querySelector('[data-result-id="' + resultId + '"]');
			if (targetEl) targetEl.style.display = '';
			showScreen('results');
		};
	}

	// ===== Add to Cart (from explicit button) =====

	var ADD_CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:inline-block;vertical-align:middle;margin-right:0.4em"><path d="M2 6 L5 9 L10 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

	function addToCartFromQuiz(variantId, btn) {
		btn.setAttribute('aria-disabled', 'true');
		var originalHTML = btn.innerHTML;
		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
		})
		.then(function (r) { return r.json(); })
		.then(function () {
			btn.innerHTML = ADD_CHECK_SVG + 'Added';
			showCartConfirmation();
			// Update cart icon bubble + drawer inner without replacing #CartDrawer (preserves overlay listener)
			Promise.all([
				fetch(window.routes.cart_url + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }),
				fetch(window.routes.cart_url + '?section_id=cart-drawer').then(function (r) { return r.text(); })
			]).then(function (htmls) {
				var parser = new DOMParser();
				var bubbleEl = document.getElementById('cart-icon-bubble');
				if (bubbleEl) {
					var bubbleSection = parser.parseFromString(htmls[0], 'text/html').querySelector('.shopify-section');
					if (bubbleSection) bubbleEl.innerHTML = bubbleSection.innerHTML;
				}
				var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
				if (drawerInner) {
					var sourceInner = parser.parseFromString(htmls[1], 'text/html').querySelector('.drawer__inner');
					if (sourceInner) {
						drawerInner.classList.remove('is-empty');
						drawerInner.innerHTML = sourceInner.innerHTML;
					}
				}
			});
		})
		.catch(function (err) { console.warn('[quiz] add to cart failed', err); })
		.finally(function () {
			btn.removeAttribute('aria-disabled');
			clearTimeout(btn._resetTimer);
			btn._resetTimer = setTimeout(function () {
				btn.innerHTML = originalHTML;
			}, 3000);
		});
	}

	// ===== Cart confirmation =====

	function showCartConfirmation() {
		var toast = document.querySelector('.quiz-onyra__cart-toast');
		if (!toast) {
			toast = document.createElement('div');
			toast.className = 'quiz-onyra__cart-toast';
			toast.innerHTML = '<svg class="quiz-onyra__cart-toast__svg" width="56" height="56" viewBox="0 0 56 56" fill="none" aria-hidden="true">'
				+ '<circle class="quiz-onyra__cart-toast__circle" cx="28" cy="28" r="24" stroke="currentColor" stroke-width="2"/>'
				+ '<path class="quiz-onyra__cart-toast__check" d="M17 29 L24 36 L39 20" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>'
				+ '</svg>'
				+ '<span>Added to your cart</span>';
			document.body.appendChild(toast);
		}

		// Reset animation by toggling visibility off first
		toast.classList.remove('is-visible');
		clearTimeout(toast._timer);

		// Trigger reflow so CSS animations restart cleanly
		void toast.offsetWidth;

		toast.classList.add('is-visible');

		// Hide 1 second after the animation completes (~650ms) + additional 1s delay
		toast._timer = setTimeout(function () {
			toast.classList.remove('is-visible');
		}, 2650);
	}

	// ===== Pill CTA helpers =====

	function updatePillForSavedResult() {
		var pill = document.querySelector('[data-quiz-cta-pill]');
		if (!pill) return;
		var titleEl = pill.querySelector('.quiz-cta-pill-onyra__title');
		if (titleEl) {
			if (!pill.dataset.originalTitle) {
				pill.dataset.originalTitle = titleEl.textContent;
			}
			titleEl.textContent = pill.dataset.returnText || 'Return to quiz results';
		}
		var iconEl = pill.querySelector('.quiz-cta-pill-onyra__return-icon');
		if (iconEl) iconEl.style.display = '';
		var ctaEl = pill.querySelector('.quiz-cta-pill-onyra__cta');
		if (ctaEl) ctaEl.style.display = 'none';
	}

	function resetPillText() {
		var pill = document.querySelector('[data-quiz-cta-pill]');
		if (!pill) return;
		var titleEl = pill.querySelector('.quiz-cta-pill-onyra__title');
		if (titleEl && pill.dataset.originalTitle) {
			titleEl.textContent = pill.dataset.originalTitle;
		}
		var iconEl = pill.querySelector('.quiz-cta-pill-onyra__return-icon');
		if (iconEl) iconEl.style.display = 'none';
		var ctaEl = pill.querySelector('.quiz-cta-pill-onyra__cta');
		if (ctaEl) ctaEl.style.display = '';
	}

	// ===== Modal open/close =====

	function initModal() {
		var modal = document.getElementById('quiz-modal');
		if (!modal) return;

		function openModal() {
			modal.classList.add('active');
			document.body.classList.add('overflow-hidden');
			// Initialize quiz inside modal if not already done
			var quizEl = modal.querySelector('.quiz-onyra');
			if (quizEl && !quizEl.dataset.quizInitialized) {
				initQuiz(quizEl);
			}
			var savedResult = sessionStorage.getItem('quiz-onyra-result');
			if (savedResult && quizEl && quizEl._jumpToResult) {
				quizEl._jumpToResult(savedResult);
			}
		}

		function closeModal() {
			modal.classList.remove('active');
			document.body.classList.remove('overflow-hidden');
		}

		// Trigger: any element with data-quiz-modal-trigger
		document.addEventListener('click', function (e) {
			var trigger = e.target.closest('[data-quiz-modal-trigger]');
			if (trigger) {
				e.preventDefault();
				openModal();
			}
		});

		// Close: overlay click
		var overlay = modal.querySelector('[data-quiz-modal-overlay]');
		if (overlay) {
			overlay.addEventListener('click', closeModal);
		}

		// Close: close button
		var closeBtn = modal.querySelector('[data-quiz-modal-close]');
		if (closeBtn) {
			closeBtn.addEventListener('click', closeModal);
		}

		// Close: Escape key
		document.addEventListener('keyup', function (e) {
			if (e.key === 'Escape' && modal.classList.contains('active')) {
				closeModal();
			}
		});
	}

	// ===== Pill scroll behaviour =====

	function initPillScrollBehavior() {
		var pillSection = document.querySelector('.quiz-cta-pill-onyra-section');
		if (!pillSection) return;

		var scrollTimer = null;

		window.addEventListener('scroll', function () {
			pillSection.classList.add('is-scrolling');
			clearTimeout(scrollTimer);
			scrollTimer = setTimeout(function () {
				pillSection.classList.remove('is-scrolling');
			}, 200);
		}, { passive: true });
	}

	// ===== Scrollbar width compensation =====

	function setScrollbarWidth() {
		var width = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar-width', width + 'px');
	}

	// ===== Bootstrap =====

	function initAll() {
		setScrollbarWidth();
		document.querySelectorAll('.quiz-onyra').forEach(function (el) {
			initQuiz(el);
		});
		initModal();
		initPillScrollBehavior();
		if (sessionStorage.getItem('quiz-onyra-result')) {
			updatePillForSavedResult();
		}
	}

	document.addEventListener('DOMContentLoaded', initAll);

	document.addEventListener('shopify:section:load', function (e) {
		var el = e.target.querySelector('.quiz-onyra');
		if (el) {
			el.removeAttribute('data-quiz-initialized');
			initQuiz(el);
		}
		// Re-init modal if the modal section was reloaded
		if (e.target.querySelector('#quiz-modal')) {
			initModal();
		}
	});
})();
